import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_ENCOUNTER_INFORMATION' as const;
export { ExportStatus as Status };
